module.exports = __webpack_public_path__ + "media/images/opioid-hospitalizations-2023-7bf5f43b5324d6a06dcf08c7325a9b63.svg";